import React from "react"
import styled from "styled-components"

import LanguagesSection from "./LanguagesSection"
import ActivitiesSection from "./ActivitiesSection"
import BooksSection from "./BooksSection"

const StyledPersonal = styled.div``

const PersonalView = () => {
  return (
    <StyledPersonal>
      <LanguagesSection/>
      <ActivitiesSection/>
      <BooksSection/>
    </StyledPersonal>
  )
}

export default PersonalView